(() => {
  const start = () => {
    document.querySelectorAll('[data-elemi-diffuser-rotator]').forEach((section) => {
      const slides = [...section.querySelectorAll('.elemi-diffuser-slide')];
      if (slides.length < 2) return;
      const title = section.querySelector('[data-diffuser-title]');
      const number = section.querySelector('[data-diffuser-number]');
      const link = section.querySelector('[data-diffuser-link]');
      const interval = Number(section.dataset.interval) || 10000;
      let active = 0;
      window.setInterval(() => {
        const next = (active + 1) % slides.length;
        const incoming = slides[next];
        section.classList.add('is-dimming');
        window.setTimeout(() => {
          slides[active].classList.remove('is-active');
          incoming.classList.add('is-active');
          active = next;
          if (title) title.textContent = incoming.dataset.title || 'Elemi diffuser';
          if (number) number.textContent = String(incoming.dataset.index || next + 1).padStart(2, '0');
          if (link) link.href = incoming.href;
          section.classList.remove('is-dimming');
        }, 550);
      }, interval);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
